import { render, staticRenderFns } from "./xiaoeCourse.vue?vue&type=template&id=6fadeec1&scoped=true"
import script from "./xiaoeCourse.vue?vue&type=script&lang=js"
export * from "./xiaoeCourse.vue?vue&type=script&lang=js"
import style0 from "./xiaoeCourse.vue?vue&type=style&index=0&id=6fadeec1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fadeec1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fadeec1')) {
      api.createRecord('6fadeec1', component.options)
    } else {
      api.reload('6fadeec1', component.options)
    }
    module.hot.accept("./xiaoeCourse.vue?vue&type=template&id=6fadeec1&scoped=true", function () {
      api.rerender('6fadeec1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/xiaoeCourse.vue"
export default component.exports